import { Box, FormControl, FormLabel, Stack } from '@chakra-ui/react';
import React from 'react';
import { useTokens } from '../../../context/TokenProvider';
import FormFieldErrors from '../FormFieldErrors/FormFieldErrors';
import { makeFilledInputStyle } from '../../../styles/inputStyles';
import DateTimePickerCustomInput from './DateTimePickerCustomInput';
import DatePickerWithTimezone from './DatePickerWithTimezone';
import { getCustomDatePickerStyles } from './datePickerStyles';
const DateTimePickerFormField = ({ error, selectedDate, label, setSelectedDate, testId, isDisabled = false, useRow = false, ...rest }) => {
    const tokens = useTokens();
    const styles = {
        input: {
            ...makeFilledInputStyle(tokens),
            w: '100%',
        },
    };
    const handleInspectionDateChange = (value) => {
        if (!value)
            return;
        setSelectedDate(value);
    };
    const datePickerStyle = getCustomDatePickerStyles(tokens);
    const stackProps = {
        direction: useRow ? 'row' : 'column',
        alignItems: useRow ? 'center' : 'flex-start',
    };
    return (React.createElement(FormControl, { w: "100%", "data-testid": testId || 'date_time_picker', sx: styles, css: datePickerStyle, isDisabled: isDisabled, isInvalid: !!error },
        React.createElement(Stack, { ...stackProps, spacing: 0 },
            React.createElement(FormLabel, { w: "50%", "data-testid": "date_time_picker__label" }, label),
            React.createElement(Box, { w: "100%" },
                React.createElement(DatePickerWithTimezone, { showTimeInput: true, disabled: isDisabled, shouldCloseOnSelect: false, selected: selectedDate, customInput: React.createElement(DateTimePickerCustomInput, { isDisabled: isDisabled }), dateFormat: "dd/MM/yyyy h:mmaaa", calendarClassName: "calendar", ...rest, onChange: (date) => handleInspectionDateChange(date) }),
                React.createElement(FormFieldErrors, { errors: error })))));
};
export default DateTimePickerFormField;
